module.exports = __webpack_public_path__ + "static/img/other.9d03252f.png";